module.exports = __webpack_public_path__ + "img/3x.a0ef4f9.jpg";